/* eslint-disable camelcase */

export const LABEL_ENTER_YOUR_CARD_DETAILS = 'Ingresa los datos de tu tarjeta';

export const DEFAULT_FEEDBACKS = [
  {
    type: 'info',
    subtitle: 'Para pagar con tarjetas de débito o prepago, usa Webpay.'
  }
];

export const DEFAULT_FORM_VALUES: IFormFields = {
  full_name: '',
  expiration_date: '',
  installments: 1,
  saveCard: true,
  termsAndConditions: true
};
